import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const NoIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M11 12L6 17L7.41422 18.4142L12.4142 13.4142L17 18L18.4142 16.5858L13.8284 12L18.7279 7.1005L17.3137 5.68629L12.4142 10.5858L7.1005 5.27208L5.68629 6.68629L11 12Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
})
NoIcon.displayName = 'NoIcon'
export default NoIcon
